import {
  UPDATE_MIXTURE_REQUEST,
  UPDATE_MIXTURE_ERROR,
  UPDATE_MIXTURE_SUCCESS,
  TOKEN_EXPIRED
} from '../types';
import context from "../common/updateEntity"
import RESOURCES from '../../api/resources';

const initialState = {};
export default (entity, entityTableData) => (state = initialState, action) => {

  context.init(context);

  context.UPDATE_ENTITY_REQUEST = UPDATE_MIXTURE_REQUEST;
  context.UPDATE_ENTITY_ERROR = UPDATE_MIXTURE_ERROR;
  context.UPDATE_ENTITY_SUCCESS = UPDATE_MIXTURE_SUCCESS;
  context.TOKEN_EXPIRED = TOKEN_EXPIRED;

  context.entityName = "mixture";
  context.entityLocation = RESOURCES.Mixtures;

  return context.execute(context)(entity, entityTableData)(state, action);
};